import request from '../utils/request'

// 菜单列表
// export function menuList(data) {
//     return request({
//         url: '/api/open/uni/listcate?pageNum='+data.pageNum+"&pageSize="+data.pageSize+"&cate_values="+data.cate_values,
//         // url: '/api/open/uni/listcate?pageNum='+ data.pageNum +"&pageSize="+ data.pageSize +"&parent_cate_value="+ data.parent_cate_value,
//         method: 'get'
//     })
// }

export function menuList(data) {
    var url = '/api/open/uni/listcates?pageNum='+ data.pageNum +"&pageSize="+ data.pageSize +"&cate_values="+ data.cate_values
    if(data.parent_cate_value != undefined && data.parent_cate_value != ''){
        url += "&parent_cate_value="+ data.parent_cate_value
    }
    return request({
        url: url,
        method: 'get'
    })
}

export function NewMenuList(data){
    return request({
        url: '/api/open/uni/listcate',
        method: 'get',
        params: data
    })
}
// 根据菜单查询
export function getMenu(data) {
    return request({
      url: '/api/open/uni/listarticle',
      method: 'get',
      params: data
    })
}
export function ChannelPolicyList(data){
    return request({
        url: '/api/open/uni/listarticle',
        method: 'get',
        params: data
    })
}

// 根据id获取详情
export function articleinfo(data){
    return request({
        url: 'api/open/uni/articleinfo?id='+data.id,
        method: 'get'
    })
}

export function listcompany(data){
    return request({
        url: '/api/open/uni/listcompany',
        method: 'get',
        params: data
    })
}
export function listcates(data){
    return request({
        url: '/api/open/uni/listcates',
        method: 'get',
        params: data
    })
    
}

// 在线专家列表
export function listexpert(data){
    return request({
        url: '/api/open/uni/listexpert',
        method: 'get',
        params: data
    })
}

export function listexpertMenu(data){
    return request({
        url: '/api/open/uni/listexpert',
        method: 'get',
        params: data
    })
}

// 公司详情
export function companyinfo(data){
    return request({
        url: '/api/open/uni/companyinfo?id='+data.id,
        method: 'get'
    })
}

// 公司产品查询
export function companyproduct(data){
    return request({
        url: '/api/open/uni/companyproduct?company_id='+data.id,
        method: 'get'
    })
}

// 专家详情
export function expertinfo(data){
    return request({
        url: '/api/open/uni/expertinfo?id='+data.id,
        method: 'get'
    })
}